import { render, staticRenderFns } from "./student-exchange.vue?vue&type=template&id=06e2592c&"
import script from "./student-exchange.vue?vue&type=script&lang=js&"
export * from "./student-exchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports